import { makeStyles } from '~/UIKit/Style';
import { CHARCOAL_GREY, GRAY_BACKGROUND } from '~/Constants/Colors.constants';

export const EventCreateSectionStyles = makeStyles(() => ({
  eventCreateSectionClassIcon: {
    height: '30px',
    width: '30px',
  },
  note: {
    width: '100%',
    color: CHARCOAL_GREY,
    backgroundColor: GRAY_BACKGROUND,
    padding: '4px 16px',
  },
  castIcon: {
    '& > svg': {
      fontSize: 24,
    },
  },
}));
